import {Button, Tooltip} from '@mantine/core';
import React from 'react';

import * as UserActions from 'actions/UserActions';
import EntityStore from 'stores/EntityStore';
import Clipboard from 'ui-library/Clipboard';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const REFERRAL_LINK_BASE = 'https://benchling.com/signup?pubref=';

interface PublicReferralLinkProps {
  email: string;
}

interface ConnectedProps extends PublicReferralLinkProps {
  referralLinkId: string | null;
}

function mapEntityStoreToProps(
  entityStore: typeof EntityStore,
  {email}: PublicReferralLinkProps
): ConnectedProps {
  return {email, referralLinkId: entityStore.getPublicReferralId(email)};
}

class PublicReferralLink extends React.Component<ConnectedProps> {
  override componentDidMount(): void {
    UserActions.getOrMakePublicReferralId(this.props.email);
  }

  override render(): JSX.Element {
    const link = REFERRAL_LINK_BASE + this.props.referralLinkId;

    const handleClickClipboard = (): void => {
      analytics.track('invites', 'copied_referral_link', {
        // @ts-expect-error
        user_id: EntityStore.currentUser()?.id,
        referral_link: link,
      });
    };

    return (
      <div className="u-large-text">
        <p>Post this link to social media, and get credit for anyone who signs up for Benchling with it!</p>
        {this.props.referralLinkId == null ? (
          <code className="copiable-link">Loading...</code>
        ) : (
          <div>
            <code className="copiable-link">{link}</code>
            <Clipboard value={link} onClick={handleClickClipboard}>
              <Tooltip label="Copy to clipboard">
                <Button aria-label="Copy to clipboard" size="xs" variant="tertiary">
                  <BenchlingIcon icon="copy" />
                </Button>
              </Tooltip>
            </Clipboard>
          </div>
        )}
      </div>
    );
  }
}

export default EntityStore.connect(mapEntityStoreToProps)(PublicReferralLink);
